export default {
  brand: "OTOSUBS",
  tagline: "Autonomous Business Technology. One Business. One Platform. Limitless Possibilities.",
  nav: {
    home: "Home", products: "Products", industries: "Industries", pricing: "Pricing",
    whyUs: "Why Us", about: "About Us", contact: "Contact Us",
    login: "Login", bookDemo: "Book a Demo", startFree: "Start Free", apps: "Apps",
  },
  common: {
    explore: "Explore", startFree: "Start Free", bookDemo: "Book a Demo", talkToSales: "Talk to Sales",
    learnMore: "Learn more", viewAll: "View all", perMonth: "/ month", monthly: "Monthly", annual: "Annual",
    annualSaving: "Annual saving", estimated: "Estimated monthly subscription", startWithPlan: "Start With This Plan",
    startSubscription: "Start Subscription", contactSales: "Contact Sales", getStarted: "Get Started",
    active: "ACTIVE", notSubscribed: "NOT SUBSCRIBED", addProduct: "Add Product", whatsappSales: "WhatsApp Sales",
    openApp: "Open App", comingSoon: "Link your app", recommended: "Recommended combination", features: "Features",
    exploreProduct: "Explore", backToProducts: "All products", backToIndustries: "All industries",
    demoMode: "Demo mode", mockNote: "This is a visual preview. Live sign-in launches with the platform.",
  },
  home: {
    eyebrow: "MASTER BUSINESS PLATFORM",
    h1a: "Run Your Entire Business",
    h1b: "From One Platform.",
    sub1: "One Platform. Multiple Business Solutions. Powered by AI.",
    sub2: "Manage your people, customers, sales, marketing, operations, cooperative, travel, store and AI communications through one connected digital ecosystem.",
    sub3: "From HR and payroll to CRM, advertising, chatbots, travel management and point-of-sale — pick only the systems your business needs.",
    exploreProducts: "Explore Products",
    trust: ["Cloud Based", "AI Powered", "Multi-Company", "Multi-Branch", "Secure", "Scalable", "API Ready"],
    pillarsEyebrow: "ONE PLATFORM",
    pillarsTitle: "Everything Your Business Runs On.",
    pillars: [
      { k: "PEOPLE", d: "Hire, pay and grow your team." },
      { k: "CUSTOMERS", d: "One CRM across every touchpoint." },
      { k: "SALES", d: "Quotes, invoices and payments." },
      { k: "MARKETING", d: "AI-built campaigns that convert." },
      { k: "OPERATIONS", d: "Projects, approvals, branches." },
      { k: "AI", d: "An assistant for every workflow." },
    ],
    ecoEyebrow: "PRODUCT ECOSYSTEM",
    ecoTitle: "Everything Your Business Needs. Connected In One Ecosystem.",
    ecoSub: "Instead of subscribing to multiple disconnected systems, manage your business through one connected platform.",
    flowEyebrow: "ONE ECOSYSTEM",
    flowTitle: "Better Together.",
    flowSub: "Every product can operate independently. But when connected, they become more powerful.",
    flows: [
      { name: "Growth Engine", steps: ["ADS BOOSTER", "WASAP AI", "CRM", "CUSTOMER", "SALES", "PAYMENT", "BLDG OPS", "REVENUE ANALYTICS"] },
      { name: "People Ops", steps: ["HR", "ATTENDANCE", "PAYROLL", "BLDG OPS", "FINANCE"] },
      { name: "Retail Loop", steps: ["STORE", "CUSTOMER", "CRM", "WASAP AI", "ADS", "LOYALTY", "REPEAT SALES"] },
      { name: "Travel Journey", steps: ["ADS", "WASAP AI", "TRAVEL CRM", "PACKAGE", "BOOKING", "PAYMENT", "DEPARTURE", "RETENTION"] },
    ],
    accountEyebrow: "ONE BUSINESS ACCOUNT",
    accountTitle: "One Login. All Your Business Apps.",
    accountSub: "Create one organisation account. No separate logins for every product.",
    switcherTitle: "Move between products without logging in again.",
    dashEyebrow: "UNIVERSAL DASHBOARD",
    dashTitle: "Your Business. One View.",
    dashGreeting: "GOOD MORNING",
    dashInsights: "BUSINESS INSIGHTS",
    aiEyebrow: "UNIVERSAL AI",
    aiTitle: "Meet Your Business AI.",
    aiSub: "One assistant for your whole business. Questions route internally to the right AI specialist — HR AI, Sales AI, Marketing AI, Finance AI and more. AI accesses only the modules and data you have permission to see.",
    aiTry: "Try asking:",
    aiQuestions: [
      "Berapa sales bulan ini?",
      "Campaign mana paling untung?",
      "Berapa staff cuti hari ini?",
      "Produk mana paling laku?",
      "Branch mana paling profitable?",
    ],
    specialistsTitle: "Behind Business AI",
    autoEyebrow: "AI AUTOMATION",
    autoTitle: "Let AI Handle Repetitive Work.",
    autoItems: [
      "AI answers customers.", "AI qualifies leads.", "AI routes leads.", "AI analyses ads.",
      "AI detects payroll anomalies.", "AI analyses business performance.", "AI summarises reports.",
      "AI identifies follow-ups.", "AI drafts documents.", "AI assists management.",
    ],
    autoNote: "Human approval remains available for sensitive decisions.",
    builderTitle: "Automation Builder",
    builderWhen: "WHEN", builderIf: "IF", builderThen: "THEN",
    builderEx1: { when: "New Lead Arrives", cond: "Interested in Product A", then: ["Assign Salesperson", "Send WhatsApp", "Create Follow-Up", "Notify Manager"] },
    builderEx2: { when: "Employee Claim > RM1,000", cond: "Always", then: ["Manager Approval", "Finance Approval"] },
    ccEyebrow: "BUSINESS COMMAND CENTRE",
    ccTitle: "Top Actions Today.",
    ccActions: [
      "42 hot leads have not been contacted.",
      "Product X inventory is approaching reorder level.",
      "Campaign A is producing stronger paid conversions.",
      "7 employee approvals are overdue.",
      "Branch B sales are below its monthly target.",
    ],
    crossTitle: "Grow Your Platform",
    crossSub: "Using HR only? Your dashboard recommends what to add next — without interrupting your work.",
    crossAdd: ["Add Wasap AI CRM for customer automation.", "Add Building Operations for facilities & operations CRM."],
    ctaEyebrow: "GET STARTED",
    ctaTitle: "One Platform. Everything Your Business Needs To Grow.",
    ctaSub: "Start with one solution. Add more when your business grows. Connect everything through one intelligent platform.",
  },
  productsPage: {
    eyebrow: "PRODUCT ECOSYSTEM",
    title: "Nine Products. One Ecosystem.",
    sub: "Each product runs independently — and becomes more powerful when connected. Pick only what your business needs today.",
  },
  industriesPage: {
    eyebrow: "INDUSTRIES",
    title: "Built For Your Industry.",
    sub: "Recommended product stacks for the way your industry actually works.",
  },
  builder: {
    eyebrow: "SOLUTION BUILDER",
    title: "Tell Us About Your Business",
    q1: "What industry are you in?",
    q2: "How many employees?",
    q3: "What do you need?",
    industries: ["Travel", "Retail", "F&B", "Cooperative", "Services", "Franchise", "Others"],
    sizes: ["1–20", "21–50", "51–200", "201–500", "500+"],
    needs: ["HR", "Payroll", "Sales", "CRM", "POS", "Advertising", "AI Chat", "Travel", "Cooperative Management"],
    result: "YOUR RECOMMENDED BUSINESS STACK",
    next: "Next", back: "Back", seeResult: "See My Stack", restart: "Start over",
  },
  pricing: {
    eyebrow: "PRICING",
    title: "Start With What You Need. Add More As Your Business Grows.",
    sub: "Do not force your business to buy everything. Start small, expand when ready.",
    startingFrom: "Starting from",
    customPricing: "Custom pricing",
    tiers: [
      { id: "starter", name: "STARTER", tag: "Essential business tools.", price: 199, features: ["Employee Management", "Basic CRM", "Documents", "Reports", "Support"], cta: "startFree" },
      { id: "growth", name: "GROWTH", tag: "For growing businesses.", price: 499, features: ["HR", "Wasap AI CRM", "Advanced Reports", "Automation"], cta: "startFree" },
      { id: "business", name: "BUSINESS", tag: "For businesses that want automation.", price: 999, features: ["HR & Payroll", "Building Operations", "Wasap AI CRM", "Ads Booster", "Advanced Analytics", "Business AI"], cta: "bookDemo" },
      { id: "enterprise", name: "ENTERPRISE", tag: "For larger organisations.", price: null, features: ["Multi-Company", "Advanced Security", "SSO", "API", "Custom Integration", "Dedicated Support", "Custom AI"], cta: "contactSales" },
    ],
    builderEyebrow: "BUILD YOUR OWN PLAN",
    builderTitle: "Build Your Business Stack",
    basePlatform: "Base Platform",
    bundlesEyebrow: "BUNDLE PRICING",
    bundlesTitle: "Industry Bundles. Built-In Savings.",
    bundleSaving: "Bundle saving",
    specialPricing: "Special enterprise pricing",
  },
  whyUs: {
    eyebrow: "WHY US",
    title: "Why Businesses Choose Us",
    items: [
      { t: "ONE PLATFORM", d: "Stop managing multiple disconnected software subscriptions." },
      { t: "AI BUILT IN", d: "AI is integrated into workflows, not simply added as a chatbot." },
      { t: "MODULAR", d: "Start with one product. Add additional modules when required." },
      { t: "ONE CUSTOMER DATABASE", d: "Customer information moves through connected workflows instead of being repeatedly entered." },
      { t: "MULTI-COMPANY", d: "Manage multiple companies from one account." },
      { t: "MULTI-BRANCH", d: "Control HQ and branches from one platform." },
      { t: "AUTOMATION", d: "Reduce repetitive administrative work." },
      { t: "REAL-TIME ANALYTICS", d: "See business performance as operations happen." },
      { t: "API READY", d: "Connect external systems through controlled APIs." },
      { t: "SCALABLE", d: "From smaller businesses to larger organisations through plans and deployment options." },
    ],
    sharedEyebrow: "SHARED PLATFORM SERVICES",
    sharedTitle: "Built Once. Shared Everywhere.",
    sharedSub: "Common capabilities are shared platform services — never rebuilt seven times.",
    shared: ["Identity Service", "Authentication", "Tenant Service", "Company Service", "Branch Service", "Employee Service", "Customer Service", "CRM Service", "Document Service", "Approval Engine", "Notification Engine", "Billing Engine", "Subscription Engine", "Payment Service", "Audit Service", "Analytics Service", "AI Gateway", "Integration Gateway", "API Gateway"],
    crmEyebrow: "UNIVERSAL CRM",
    crmTitle: "One Shared Customer Foundation.",
    crmSub: "One customer profile — name, contact, source, campaign, purchases, bookings, conversations, payments, notes and customer value. Each product adds its own domain records on top.",
    commsEyebrow: "UNIVERSAL COMMUNICATION CENTRE",
    commsTitle: "Every Channel. One Inbox.",
    commsSub: "WhatsApp, Messenger, Instagram, Website Chat, Email and Social Comments flow into one inbox — powered by AI, your team, and the CRM.",
    notifEyebrow: "UNIVERSAL NOTIFICATIONS",
    notifTitle: "One Notification Centre.",
    notifs: ["Payroll approval required.", "New sales lead.", "Customer payment received.", "Stock low.", "Campaign requires attention.", "New travel booking.", "Financing application awaiting approval."],
    marketEyebrow: "MARKETPLACE",
    marketTitle: "App Marketplace. Coming Soon.",
    marketSub: "Install accounting, e-invoice, payment gateways, WhatsApp, banks, e-commerce, biometric, e-signature, logistics, analytics and external apps — a future revenue stream for the ecosystem.",
    partnerEyebrow: "PARTNER / RESELLER",
    partnerTitle: "Sell The Platform. Earn Recurring Commission.",
    partnerSub: "Partners can sell individual apps, bundles, the complete platform or white label — with a dashboard for leads, customers, subscriptions, commission, renewals and support.",
    ownerEyebrow: "PLATFORM OWNER",
    ownerTitle: "One Dashboard For The Whole Platform.",
    ownerSub: "Tenants, active customers, MRR, ARR, churn, trials, conversion, adoption, AI usage, storage, support and revenue by product.",
  },
  about: {
    eyebrow: "ABOUT US",
    title: "Building The Operating System For Modern Businesses.",
    p1: "We believe businesses should not need multiple disconnected systems to run their daily operations.",
    p2: "Our platform brings people, customers, sales, marketing, operations and AI into one connected ecosystem. Businesses can start with the tools they need today and add more capabilities as they grow.",
    missionTitle: "Our Mission",
    mission: "Make powerful business technology simple, connected and accessible.",
    visionTitle: "Our Vision",
    vision: "One Platform To Run Your Business.",
    visionSub: "An intelligent business ecosystem where people, customers, sales, marketing, operations, data and AI work together.",
    archEyebrow: "PLATFORM ARCHITECTURE",
    archTitle: "One Master Platform. Seven Module Services.",
    archSub: "Every module uses the same identity, CRM, document, approval, analytics and AI foundation.",
  },
  contact: {
    eyebrow: "CONTACT",
    title: "Let's Transform Your Business.",
    sub: "Interested in seeing how the platform works? Book a personalised demonstration.",
    fullName: "Full Name", company: "Company", email: "Email", phone: "Phone",
    industry: "Industry", employees: "Employees", products: "Interested Products", message: "Message",
    submit: "BOOK MY DEMO", submitting: "Sending...",
    successTitle: "Request received!",
    successSub: "Our team will contact you shortly to schedule your demo.",
    another: "Send another request",
    industryOptions: ["Travel", "Retail", "F&B", "Cooperative", "SME", "Franchise", "Professional Services", "Others"],
    employeeOptions: ["1–20", "21–50", "51–200", "201–500", "500+"],
    error: "Something went wrong. Please try again.",
  },
  auth: {
    loginTitle: "Welcome back", loginSub: "One login. All your business apps.",
    signupTitle: "Create your business account", signupSub: "Start free. Add products as you grow.",
    email: "Work email", password: "Password", name: "Full name", company: "Company name",
    loginBtn: "Login", signupBtn: "Create Account",
    noAccount: "No account yet?", haveAccount: "Already have an account?",
    mockBtn: "Continue (Demo)",
  },
  chat: {
    title: "Business AI",
    sub: "Demo assistant — scripted answers",
    greeting: "Hi! I'm your Business AI. Ask me anything about the platform — or tap a question below.",
    placeholder: "Ask about pricing, products...",
    quick: [
      { q: "How does HR sync with POS?", a: "Great question! Employee records live in HR SaaS. When you add STORE SaaS, the same employee profiles power cashier logins, shift-based POS access and sales-per-staff analytics — one identity, zero double entry." },
      { q: "Show pricing savings", a: "Buying separately? 7 disconnected tools typically cost RM3,000+/month. With OTOSUBS bundles you save 20% instantly, plus annual billing saves another 2 months. Try the Build Your Stack calculator on the Pricing page!" },
      { q: "Connect my ads to CRM", a: "ADS BOOSTER captures leads from Meta & Google, pushes them into the universal CRM, and WASAP AI follows up on WhatsApp automatically. Revenue attribution shows exactly which campaign produced each sale." },
      { q: "Berapa sales bulan ini?", a: "Demo answer: Sales bulan ini RM684K — 12% lebih tinggi dari bulan lepas. Produk paling laku: Pakej Umrah VIP. (In the live platform, Business AI answers from your real data.)" },
    ],
    fallback: "I'm a scripted demo assistant. In the live platform, Business AI connects to your real data across HR, sales, marketing and finance. Try one of the quick questions, or book a demo to see the real thing!",
  },
  footer: {
    products: "PRODUCTS", industries: "INDUSTRIES", company: "COMPANY", resources: "RESOURCES", legal: "LEGAL",
    companyLinks: ["Why Us", "Contact", "Partners", "Careers"],
    resourceLinks: ["Help Centre", "Blog", "API", "Documentation", "System Status"],
    legalLinks: ["Terms", "Privacy", "PDPA", "Security", "Data Processing"],
    rights: "All rights reserved.",
    promise: "ONE BUSINESS. ONE PLATFORM. LIMITLESS POSSIBILITIES.",
  },
  notFound: { title: "Page not found", sub: "The page you are looking for does not exist.", back: "Back to home" },
};
